import React from 'react';

import PropTypes from 'prop-types';

import Form from 'components/form-multi/Form';

import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'constants/formName';

import { PromoButton } from '../common/promo-button/PromoButton';
import { PromoText } from '../common/promo-text/PromoText';
import { PromoRow } from '../common/PromoRow/PromoRow';
import PromoInputPhoneWithDropdown from '../form/PromoInputPhoneWithDropdown/PromoInputPhoneWithDropdown';

export const HeroExtraBlock = (props) => {
    return (
        <Form formName={NO_AUTH_LOGIN_REGISTRATION_FORM_NAME}>
            {props.extraBlockTitle && (
                <PromoRow indent={'adaptive-24-32'} textAlign={'center'}>
                    <PromoText variant="subheader">{props.extraBlockTitle}</PromoText>
                </PromoRow>
            )}
            <PromoRow indent={'adaptive-24-32'}>
                <PromoInputPhoneWithDropdown
                    countries={props.countries}
                    currentCountry={props.currentCountry}
                    labelText={props.labelText}
                    searchPlaceholder={props.searchPlaceholder}
                    searchFullPlaceholder={props.searchFullPlaceholder}
                    searchModalTitle={props.searchModalTitle}
                    searchNoResult={props.searchNoResult}
                    isNonEditableCountry={props.isNonEditableCountry}
                />
            </PromoRow>
            <PromoRow textAlign={'center'}>
                <PromoButton
                    type={'button'}
                    onClick={props.onExtraButtonClick}
                    onKeyPress={props.onExtraButtonClick}
                    caption={props.btnTitle}
                    variant={props.btnVariant}
                    id={'acceptInviteBtn'}
                    disabled={props.disabledBtn}
                />
            </PromoRow>
        </Form>
    );
};

HeroExtraBlock.propTypes = {
    labelText: PropTypes.string,
    btnTitle: PropTypes.string,
    btnVariant: PropTypes.string,
    onExtraButtonClick: PropTypes.func,
    disabledBtn: PropTypes.bool,
    extraBlockTitle: PropTypes.string,
};
